import React, { useState } from "react";
import {
  Box,
  Input,
  Button,
  FormControl,
  FormLabel,
  VStack,
  Text,
  useToast,
} from "@chakra-ui/react";

interface CreateTableFromFileProps {
  onBack?: () => void;
}

const CreateTableFromFile: React.FC<CreateTableFromFileProps> = ({ onBack }) => {
  const [tableName, setTableName] = useState("");
  const [file, setFile] = useState<File | null>(null);
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = e.target.files?.[0];
    if (selectedFile) {
      setFile(selectedFile);
    }
  };

  const handleSubmit = async () => {
    if (!tableName || !file) {
      toast({
        title: "Missing table name or file.",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }
const Base_apiUrl=process.env.REACT_APP_API_Base_Url;
    const formData = new FormData();
    formData.append("TableName", tableName);
    formData.append("File", file);

    setLoading(true);
    try {
      const response = await fetch(
        `${Base_apiUrl}FileAction/UploadTableFromFile`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error("Upload failed. Please try again.");
      }

      toast({
        title: `Table "${tableName}" created from file "${file.name}"`,
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      // Optionally, reset form or go back
      setTableName("");
      setFile(null);
      if (onBack) onBack();
    } catch (error: any) {
      toast({
        title: "Upload failed",
        description: error.message || "An error occurred.",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      maxW="500px"
      mx="auto"
      mt={8}
      p={6}
      borderWidth="1px"
      borderRadius="lg"
    >
      <VStack spacing={4}>
        <FormControl isRequired>
          <FormLabel>Table Name</FormLabel>
          <Input
            placeholder="Enter table name"
            value={tableName}
            onChange={(e) => setTableName(e.target.value)}
          />
        </FormControl>

        <FormControl isRequired>
          <FormLabel>Upload CSV File</FormLabel>
          <Input type="file" accept=".csv" onChange={handleFileChange} />
          {file && <Text fontSize="sm">Selected file: {file.name}</Text>}
        </FormControl>

        <Button
          colorScheme="teal"
          onClick={handleSubmit}
          width="full"
          isLoading={loading}
        >
          Create Table
        </Button>
      </VStack>
    </Box>
  );
};

export default CreateTableFromFile;
